// ASHRAE Design Conditions for major cities in USA and Canada
// Summer: 0.4% cooling design DB/MCWB
// Winter: 99% heating design DB

export const ASHRAE_DESIGN_CONDITIONS = {
  USA: {
    // Top 100 US Cities with ASHRAE design conditions
    "New York, NY": { summer_db: 93, summer_wb: 75, winter_db: 14 },
    "Los Angeles, CA": { summer_db: 93, summer_wb: 70, winter_db: 43 },
    "Chicago, IL": { summer_db: 93, summer_wb: 76, winter_db: -4 },
    "Houston, TX": { summer_db: 97, summer_wb: 78, winter_db: 31 },
    "Phoenix, AZ": { summer_db: 110, summer_wb: 71, winter_db: 38 },
    "Philadelphia, PA": { summer_db: 93, summer_wb: 76, winter_db: 14 },
    "San Antonio, TX": { summer_db: 99, summer_wb: 75, winter_db: 28 },
    "San Diego, CA": { summer_db: 86, summer_wb: 69, winter_db: 44 },
    "Dallas, TX": { summer_db: 101, summer_wb: 76, winter_db: 22 },
    "San Jose, CA": { summer_db: 92, summer_wb: 68, winter_db: 36 },
    "Austin, TX": { summer_db: 101, summer_wb: 75, winter_db: 28 },
    "Jacksonville, FL": { summer_db: 96, summer_wb: 78, winter_db: 32 },
    "Fort Worth, TX": { summer_db: 101, summer_wb: 76, winter_db: 21 },
    "Columbus, OH": { summer_db: 91, summer_wb: 74, winter_db: 5 },
    "San Francisco, CA": { summer_db: 83, summer_wb: 63, winter_db: 39 },
    "Charlotte, NC": { summer_db: 95, summer_wb: 76, winter_db: 22 },
    "Indianapolis, IN": { summer_db: 92, summer_wb: 76, winter_db: 2 },
    "Seattle, WA": { summer_db: 85, summer_wb: 66, winter_db: 27 },
    "Denver, CO": { summer_db: 95, summer_wb: 60, winter_db: 1 },
    "Washington, DC": { summer_db: 95, summer_wb: 77, winter_db: 17 },
    "Boston, MA": { summer_db: 91, summer_wb: 74, winter_db: 9 },
    "El Paso, TX": { summer_db: 101, summer_wb: 66, winter_db: 24 },
    "Nashville, TN": { summer_db: 95, summer_wb: 77, winter_db: 14 },
    "Detroit, MI": { summer_db: 91, summer_wb: 74, winter_db: 6 },
    "Oklahoma City, OK": { summer_db: 100, summer_wb: 75, winter_db: 13 },
    "Portland, OR": { summer_db: 91, summer_wb: 67, winter_db: 26 },
    "Las Vegas, NV": { summer_db: 108, summer_wb: 68, winter_db: 30 },
    "Memphis, TN": { summer_db: 97, summer_wb: 78, winter_db: 18 },
    "Louisville, KY": { summer_db: 94, summer_wb: 77, winter_db: 10 },
    "Baltimore, MD": { summer_db: 94, summer_wb: 77, winter_db: 13 },
    "Milwaukee, WI": { summer_db: 90, summer_wb: 74, winter_db: -6 },
    "Albuquerque, NM": { summer_db: 96, summer_wb: 62, winter_db: 17 },
    "Tucson, AZ": { summer_db: 105, summer_wb: 68, winter_db: 32 },
    "Fresno, CA": { summer_db: 104, summer_wb: 70, winter_db: 31 },
    "Sacramento, CA": { summer_db: 101, summer_wb: 70, winter_db: 32 },
    "Mesa, AZ": { summer_db: 110, summer_wb: 71, winter_db: 38 },
    "Kansas City, MO": { summer_db: 97, summer_wb: 77, winter_db: 4 },
    "Atlanta, GA": { summer_db: 94, summer_wb: 76, winter_db: 22 },
    "Long Beach, CA": { summer_db: 87, summer_wb: 69, winter_db: 43 },
    "Omaha, NE": { summer_db: 95, summer_wb: 77, winter_db: -3 },
    "Raleigh, NC": { summer_db: 94, summer_wb: 77, winter_db: 20 },
    "Colorado Springs, CO": { summer_db: 91, summer_wb: 59, winter_db: 1 },
    "Miami, FL": { summer_db: 92, summer_wb: 79, winter_db: 47 },
    "Virginia Beach, VA": { summer_db: 93, summer_wb: 78, winter_db: 24 },
    "Oakland, CA": { summer_db: 85, summer_wb: 63, winter_db: 37 },
    "Minneapolis, MN": { summer_db: 92, summer_wb: 74, winter_db: -12 },
    "Tulsa, OK": { summer_db: 100, summer_wb: 77, winter_db: 13 },
    "Arlington, TX": { summer_db: 101, summer_wb: 76, winter_db: 22 },
    "Tampa, FL": { summer_db: 93, summer_wb: 79, winter_db: 40 },
    "New Orleans, LA": { summer_db: 94, summer_wb: 79, winter_db: 33 },
    "Wichita, KS": { summer_db: 100, summer_wb: 75, winter_db: 7 },
    "Cleveland, OH": { summer_db: 90, summer_wb: 74, winter_db: 5 },
    "Bakersfield, CA": { summer_db: 105, summer_wb: 71, winter_db: 32 },
    "Aurora, CO": { summer_db: 95, summer_wb: 60, winter_db: 1 },
    "Anaheim, CA": { summer_db: 95, summer_wb: 71, winter_db: 39 },
    "Honolulu, HI": { summer_db: 89, summer_wb: 75, winter_db: 63 },
    "Santa Ana, CA": { summer_db: 93, summer_wb: 71, winter_db: 41 },
    "Riverside, CA": { summer_db: 104, summer_wb: 72, winter_db: 35 },
    "Corpus Christi, TX": { summer_db: 95, summer_wb: 79, winter_db: 36 },
    "Lexington, KY": { summer_db: 93, summer_wb: 76, winter_db: 10 },
    "Stockton, CA": { summer_db: 100, summer_wb: 70, winter_db: 32 },
    "Henderson, NV": { summer_db: 108, summer_wb: 68, winter_db: 30 },
    "Saint Paul, MN": { summer_db: 92, summer_wb: 74, winter_db: -12 },
    "St. Louis, MO": { summer_db: 96, summer_wb: 77, winter_db: 6 },
    "Cincinnati, OH": { summer_db: 93, summer_wb: 76, winter_db: 8 },
    "Pittsburgh, PA": { summer_db: 90, summer_wb: 73, winter_db: 7 },
    "Greensboro, NC": { summer_db: 93, summer_wb: 76, winter_db: 19 },
    "Anchorage, AK": { summer_db: 71, summer_wb: 60, winter_db: -7 },
    "Lincoln, NE": { summer_db: 97, summer_wb: 76, winter_db: -3 },
    "Plano, TX": { summer_db: 101, summer_wb: 76, winter_db: 22 },
    "Orlando, FL": { summer_db: 94, summer_wb: 78, winter_db: 38 },
    "Irvine, CA": { summer_db: 90, summer_wb: 69, winter_db: 42 },
    "Newark, NJ": { summer_db: 94, summer_wb: 76, winter_db: 14 },
    "Toledo, OH": { summer_db: 91, summer_wb: 75, winter_db: 3 },
    "Durham, NC": { summer_db: 94, summer_wb: 77, winter_db: 20 },
    "Chula Vista, CA": { summer_db: 86, summer_wb: 69, winter_db: 44 },
    "Fort Wayne, IN": { summer_db: 91, summer_wb: 75, winter_db: 1 },
    "Jersey City, NJ": { summer_db: 94, summer_wb: 76, winter_db: 14 },
    "St. Petersburg, FL": { summer_db: 93, summer_wb: 79, winter_db: 42 },
    "Laredo, TX": { summer_db: 103, summer_wb: 77, winter_db: 36 },
    "Madison, WI": { summer_db: 91, summer_wb: 74, winter_db: -7 },
    "Chandler, AZ": { summer_db: 110, summer_wb: 71, winter_db: 38 },
    "Buffalo, NY": { summer_db: 88, summer_wb: 72, winter_db: 6 },
    "Lubbock, TX": { summer_db: 99, summer_wb: 68, winter_db: 14 },
    "Scottsdale, AZ": { summer_db: 110, summer_wb: 71, winter_db: 38 },
    "Reno, NV": { summer_db: 97, summer_wb: 61, winter_db: 13 },
    "Glendale, AZ": { summer_db: 110, summer_wb: 71, winter_db: 38 },
    "Gilbert, AZ": { summer_db: 110, summer_wb: 71, winter_db: 38 },
    "Winston-Salem, NC": { summer_db: 93, summer_wb: 76, winter_db: 18 },
    "North Las Vegas, NV": { summer_db: 108, summer_wb: 68, winter_db: 30 },
    "Norfolk, VA": { summer_db: 94, summer_wb: 78, winter_db: 24 },
    "Chesapeake, VA": { summer_db: 94, summer_wb: 78, winter_db: 24 },
    "Garland, TX": { summer_db: 101, summer_wb: 76, winter_db: 22 },
    "Irving, TX": { summer_db: 101, summer_wb: 76, winter_db: 22 },
    "Hialeah, FL": { summer_db: 92, summer_wb: 79, winter_db: 47 },
    "Fremont, CA": { summer_db: 89, summer_wb: 65, winter_db: 36 },
    "Boise, ID": { summer_db: 98, summer_wb: 64, winter_db: 10 },
    "Richmond, VA": { summer_db: 95, summer_wb: 77, winter_db: 17 },
    "Baton Rouge, LA": { summer_db: 95, summer_wb: 79, winter_db: 29 },
  },
  Canada: {
    // Top 20 Canadian Cities with ASHRAE design conditions
    "Toronto, ON": { summer_db: 90, summer_wb: 74, winter_db: -2 },
    "Montreal, QC": { summer_db: 88, summer_wb: 73, winter_db: -9 },
    "Vancouver, BC": { summer_db: 79, summer_wb: 66, winter_db: 23 },
    "Calgary, AB": { summer_db: 86, summer_wb: 60, winter_db: -18 },
    "Edmonton, AB": { summer_db: 84, summer_wb: 62, winter_db: -22 },
    "Ottawa, ON": { summer_db: 90, summer_wb: 73, winter_db: -13 },
    "Winnipeg, MB": { summer_db: 90, summer_wb: 72, winter_db: -25 },
    "Quebec City, QC": { summer_db: 86, summer_wb: 72, winter_db: -13 },
    "Hamilton, ON": { summer_db: 90, summer_wb: 74, winter_db: 2 },
    "Kitchener, ON": { summer_db: 89, summer_wb: 74, winter_db: 0 },
    "London, ON": { summer_db: 89, summer_wb: 74, winter_db: 1 },
    "Victoria, BC": { summer_db: 75, summer_wb: 63, winter_db: 28 },
    "Halifax, NS": { summer_db: 82, summer_wb: 69, winter_db: 3 },
    "Oshawa, ON": { summer_db: 89, summer_wb: 74, winter_db: 0 },
    "Windsor, ON": { summer_db: 92, summer_wb: 75, winter_db: 6 },
    "Saskatoon, SK": { summer_db: 88, summer_wb: 66, winter_db: -27 },
    "Regina, SK": { summer_db: 91, summer_wb: 67, winter_db: -26 },
    "St. John's, NL": { summer_db: 77, summer_wb: 66, winter_db: 7 },
    "Barrie, ON": { summer_db: 88, summer_wb: 73, winter_db: -6 },
    "Kelowna, BC": { summer_db: 93, summer_wb: 65, winter_db: 5 },
  },
  Serbia: {
    // ASHRAE 2025 Handbook Fundamentals Ch.14 — Station 132740 (Belgrade)
    "Belgrade": { summer_db: 95, summer_wb: 71, winter_db: 17 },
  },
};

export const getCountries = () => Object.keys(ASHRAE_DESIGN_CONDITIONS);

export const getCities = (country) => {
  if (!country || !ASHRAE_DESIGN_CONDITIONS[country]) return [];
  return Object.keys(ASHRAE_DESIGN_CONDITIONS[country]).sort();
};

// Approximate elevations (ft) for ASHRAE cities
const CITY_ELEVATIONS = {
  // USA
  "New York, NY": 33, "Los Angeles, CA": 285, "Chicago, IL": 597, "Houston, TX": 80,
  "Phoenix, AZ": 1086, "Philadelphia, PA": 39, "San Antonio, TX": 650, "San Diego, CA": 62,
  "Dallas, TX": 430, "San Jose, CA": 82, "Austin, TX": 489, "Jacksonville, FL": 12,
  "Fort Worth, TX": 653, "Columbus, OH": 902, "San Francisco, CA": 52, "Charlotte, NC": 751,
  "Indianapolis, IN": 717, "Seattle, WA": 175, "Denver, CO": 5280, "Washington, DC": 0,
  "Boston, MA": 20, "El Paso, TX": 3740, "Nashville, TN": 597, "Detroit, MI": 600,
  "Oklahoma City, OK": 1197, "Portland, OR": 50, "Las Vegas, NV": 2001, "Memphis, TN": 337,
  "Louisville, KY": 462, "Baltimore, MD": 33, "Milwaukee, WI": 617, "Albuquerque, NM": 5312,
  "Tucson, AZ": 2389, "Fresno, CA": 308, "Sacramento, CA": 30, "Mesa, AZ": 1243,
  "Kansas City, MO": 741, "Atlanta, GA": 1050, "Long Beach, CA": 30, "Omaha, NE": 1090,
  "Raleigh, NC": 315, "Colorado Springs, CO": 6035, "Miami, FL": 6, "Virginia Beach, VA": 12,
  "Oakland, CA": 42, "Minneapolis, MN": 830, "Tulsa, OK": 700, "Arlington, TX": 604,
  "Tampa, FL": 48, "New Orleans, LA": 3, "Wichita, KS": 1299, "Cleveland, OH": 653,
  "Bakersfield, CA": 404, "Aurora, CO": 5471, "Anaheim, CA": 157, "Honolulu, HI": 18,
  "Santa Ana, CA": 115, "Riverside, CA": 840, "Corpus Christi, TX": 44, "Lexington, KY": 978,
  "Stockton, CA": 13, "Henderson, NV": 1864, "Saint Paul, MN": 780, "St. Louis, MO": 466,
  "Cincinnati, OH": 482, "Pittsburgh, PA": 1223, "Greensboro, NC": 897, "Anchorage, AK": 101,
  "Lincoln, NE": 1176, "Plano, TX": 659, "Orlando, FL": 82, "Irvine, CA": 57,
  "Newark, NJ": 30, "Toledo, OH": 614, "Durham, NC": 404, "Chula Vista, CA": 62,
  "Fort Wayne, IN": 790, "Jersey City, NJ": 25, "St. Petersburg, FL": 44, "Laredo, TX": 430,
  "Madison, WI": 869, "Chandler, AZ": 1211, "Buffalo, NY": 600, "Lubbock, TX": 3256,
  "Scottsdale, AZ": 1257, "Reno, NV": 4505, "Glendale, AZ": 1143, "Gilbert, AZ": 1229,
  "Winston-Salem, NC": 925, "North Las Vegas, NV": 1920, "Norfolk, VA": 14,
  "Chesapeake, VA": 12, "Garland, TX": 535, "Irving, TX": 462, "Hialeah, FL": 6,
  "Fremont, CA": 56, "Boise, ID": 2730, "Richmond, VA": 167, "Baton Rouge, LA": 56,
  // Canada
  "Toronto, ON": 249, "Montreal, QC": 118, "Vancouver, BC": 0, "Calgary, AB": 3557,
  "Edmonton, AB": 2192, "Ottawa, ON": 230, "Winnipeg, MB": 760, "Quebec City, QC": 243,
  "Hamilton, ON": 238, "Kitchener, ON": 1070, "London, ON": 846, "Victoria, BC": 66,
  "Halifax, NS": 145, "Oshawa, ON": 338, "Windsor, ON": 620, "Saskatoon, SK": 1580,
  "Regina, SK": 1893, "St. John's, NL": 460, "Barrie, ON": 866, "Kelowna, BC": 1129,
  // Serbia
  "Belgrade": 433,
};

export const getDesignConditions = (country, city) => {
  if (!country || !city || !ASHRAE_DESIGN_CONDITIONS[country]) return null;
  const conditions = ASHRAE_DESIGN_CONDITIONS[country][city];
  if (!conditions) return null;
  return {
    ...conditions,
    elevation_ft: CITY_ELEVATIONS[city] ?? 0,
  };
};
